"use strict";

exports.__esModule = true;
exports.default = void 0;
var _helpers = require("../../helpers");
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const invitationRoleActions = new _helpers.JoinActionHelper('invitation', 'role');
const invitationActions = new _helpers.ActionHelper({
  singular: 'invitation'
});
class Actions extends _helpers.ActionHelper {
  constructor() {
    super({
      singular: 'invitation'
    });
    _defineProperty(this, "addRole", body => invitationRoleActions.create(body, this));
    _defineProperty(this, "dropRole", id => invitationRoleActions.destroy(id, this));
    _defineProperty(this, "getMyInvitation", (id, params) => invitationActions.get(id, params, this, false));
    _defineProperty(this, "get", (id, params) => invitationActions.get(id, params, this, true));
  }

  //create = (body, params) => invitationActions.create(body, params, this, false);
}
const actions = new Actions();
var _default = exports.default = actions;
module.exports = exports.default;